
import { styled } from '@mui/material';
import EDBox from '../../EDBox/EDBox';
import EDTypography from '../../Typography/EDTypography';
import { weekNo } from '../../../Utils/dateUtils';

interface IProps {
  date: Date;
}

export const EDCalendarViewWeekNumberBox: React.FC<IProps> = props => {
  const weekNumber = weekNo(props.date);
  return (
    <Container>
      <WeekBox>
        <WeekText>v {weekNumber}</WeekText>
      </WeekBox>
    </Container>
  );
};

const Container = styled(EDBox, {
  name: 'WeekNumberContainer',
})({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const WeekBox = styled(EDBox, {
  name: 'WeekNumberBox',
})(({ theme }) => ({
  marginTop: theme.spacing(0.25),
  border: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.25, 0.75),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: theme.spacing(4.5),
}));

const WeekText = styled(EDTypography, {
  name: 'WeekNumberText',
})(({ theme }) => ({
  fontSize: 11,
  color: theme.palette.text.primary,
}));

export default EDCalendarViewWeekNumberBox;
